module.exports = __webpack_public_path__ + "front/img/poster2.847a9cb3.jpg";